// extracted by mini-css-extract-plugin
module.exports = {"s1td9zev":"s1td9zev"};